<template >
  <dashboard v-if="authenticated" :keycloak="keycloak"/>
</template>

<script>
import Dashboard from "@/components/Dashboard";

export default {
  name: "App",
  props: ["authenticated", "keycloak"],
  components: {
    Dashboard
  }
};
</script>
